<template lang="pug">
.answers.answers-choose-many
	bunt-checkbox.answer(v-for="option in question.answer.options", v-model="answer[option.value]", @click="$store.dispatch('anwserCurrentQuestion', option.value)") {{ option.text }}
	bunt-button.btn-next(@click="next", name="date") Weiter
</template>
<script>
export default {
	components: {},
	props: {
		question: Object
	},
	data () {
		const answer = {}
		for (const option of this.question.answer.options) {
			answer[option.value] = false
		}
		return {
			answer
		}
	},
	methods: {
		next () {
			this.$store.dispatch('anwserCurrentQuestion', this.answer)
		}
	}
}
</script>
<style lang="stylus">
@import '~settings'
.questionnaire-form .step .answers-choose-many
	display: flex
	flex-direction: column
	.answer
		margin: 16px
		checkbox-style(color: $clr-primary, size: 'large')
</style>
